import React from 'react'
import * as R from 'ramda'

import { PaymentInfoContainer } from './paymentInfo'
import { Plans } from './plans'
import BillingDetailFormContainer from './BillingDetailForm/container'

/**
 *
 * @param {object} props
 * @param {object} props.billing
 * @param {object} props.user
 * @param {object} props.plans
 */
export const BillingPresentation = ({ billing, user, plans }) => {
  const latestInvoice = R.path(['invoices', 0], billing)
  const hasCard = Boolean(billing.card)
  const subscription = billing.subscription
  const isShowPaymentMethod =
    R.prop('status', subscription) !== 'trialing' &&
    (R.prop('status', subscription) !== 'canceled' || hasCard)
  return (
    <div className="ui stackable grid">
      <div className="twelve wide column">
        <React.Fragment>
          <Plans
            billing={billing}
            user={user}
            latestInvoice={latestInvoice}
            plans={plans}
            hasCard={hasCard}
          />
          <p>
            <a
              href="https://help.simplesat.io/en/articles/1754490-billing-plans"
              target="_blank"
              rel="noreferrer"
            >
              <i className="icon far fa-book mt20" />
              More about Simplesat plans and billing
            </a>
          </p>
          {isShowPaymentMethod && <PaymentInfoContainer card={billing.card} billing={billing} />}
          <BillingDetailFormContainer
            companyName={billing.billing_detail.company_name}
            billing={billing}
          />
        </React.Fragment>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/Billing/index.js